import { Nav } from "react-bootstrap";
import { signoutSchoolForm } from "../Auth";
import Button from "react-bootstrap/Button";
const SchoolSidebar = () => {
  return (
    <div
      style={{
        width: "130px",
        backgroundColor: "#0d6efd",
        color: "white",
        paddingTop: "20px",
        position: "relative",
      }}
    >
      {/* Title (hide when collapsed) */}

      {/* Menu */}
      <Nav className="flex-column px-2">
        <Nav.Link href="/school-form" className="text-white mb-2">
          {"Home"}
        </Nav.Link>

        <Nav.Link href="/view-forms" className="text-white mb-2">
          {"View Filled Forms"}
        </Nav.Link>

        <Nav.Link href="/completed-orders" className="text-white mb-2">
          {"View Completed Orders"}
        </Nav.Link>

        <Nav.Link href="/pending-students" className="text-white mb-2">
          {"View Pending Students"}
        </Nav.Link>

        <Nav.Item>
          <Button
            variant="link"
            className="text-white mb-2 p-0 text-start"
            onClick={signoutSchoolForm}
          >
            Logout
          </Button>
        </Nav.Item>
      </Nav>
    </div>
  );
};

export default SchoolSidebar;
